import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { Language } from '@classes/language';
import { LanguageService } from '@services/language.service';

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
    languageForm: FormGroup;
    languageList: Language[];
    isLoading: boolean;

    constructor(
        private fb: FormBuilder,
        private langSrv: LanguageService,
        private translateSrv: TranslateService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.isLoading = true;

        this.langSrv.getList()
        .subscribe(languages => {
            this.languageList = languages;
            this.initForm();
            this.isLoading = false;
        });
    }

    private initForm(): void {
        const browserLang = this.translateSrv.getBrowserLang();
        const lang = this.languageList.find(l => l.codeISO === browserLang) || this.languageList[0];

        this.languageForm = this.fb.group({
            lang: [lang]
        });

        this.languageForm.controls.lang.valueChanges
        .subscribe((selected: Language) => {
            this.langSrv.setCurrentLanguage(selected.codeISO);
        });
    }
}
